import Crud from '../views/TipoGestao/Crud'
import Entity from '../views/TipoGestao/Add'
import View from '../views/TipoGestao/View'

let routes = {
    path: '/tipo_gestoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_gestoes/add',
            name: 'NewTipoGestao',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Tipos de Gestões',
                breadcrumb: [
                    {
                        text: 'Tipos de Gestões',
                        active: false,
                        to: '/tipo_gestoes',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_gestoes/edit/:id?',
            name: 'EditTipoGestao',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Tipos de Gestões',
                breadcrumb: [
                    {
                        text: 'Tipos de Gestões',
                        active: false,
                        to: '/tipo_gestoes',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_gestoes/view/:id?',
            name: 'ViewTipoGestao',
            component: View,
            meta: {
                pageTitle: 'Visualizar Tipos de Gestões',
                breadcrumb: [
                    {
                        text: 'Tipos de Gestões',
                        active: false,
                        to: '/tipo_gestoes',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_gestoes',
            name: 'list-tipo_gestoes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Gestões',
                breadcrumb: [
                    {
                        text: 'Tipos de Gestões',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
